<template>
  <b-overlay :show="loading || pdfLoading">
    <div class="worker-id-document p-4"> <!-- Mustafijur: 20-05-2026 -->
      <div
        class="form-section-header d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 p-3 rounded text-center text-md-left"
        style="background-color: #eaf6ff"
      >
        <div class="text-center  w-100">
          <p class="mb-0 font-weight-bold" style="color: #333; font-size: 0.85rem;">Bangladesh Gazette - বাংলাদেশ গেজেট</p>
          <h6 class="mb-0 font-weight-bold" style="color: #007bff">
            Form No: 07
          </h6>
          <small class="text-muted" style="font-size: 0.75rem"
            >Under Section 7, Rule 7(1) and (2) <br />
            First Part (A) <br />
            </small
          >
          <!-- Mustafijur: 20-05-2026: removed from strong added in h6 -->
          <h6 class="mb-0 font-weight-bold">
            Worker Identification Document
          </h6>
          <p class="mb-0 small bn-text">শ্রমিকের সনাক্তকরনের তথ্য</p>
        </div>
       <div class="d-flex flex-column flex-md-row align-items-center mt-3 mt-md-0">
        <b-button
            variant="primary"
            size="sm"
            class="d-flex align-items-center text-nowrap mb-2 mb-md-0 mr-md-2"
            style="min-width: 160px;"
            @click="saveData"
            :disabled="loading || !isEditMode"
        >
            <b-icon icon="check-circle" class="mr-1"></b-icon>
            Save Changes
        </b-button>

        <b-button
            :variant="isEditMode ? 'danger' : 'primary'"
            size="sm"
            class="d-flex align-items-center text-nowrap"
            :class="{ 'service-book-btn-danger': isEditMode }"
            style="min-width: 160px;"
            @click="toggleEditMode"
        >
            <b-icon
                :icon="isEditMode ? 'x-circle' : 'pencil-square'"
                class="mr-1"
            ></b-icon>
            {{ isEditMode ? "Disable Edit Mode" : "Enable Edit Mode" }}
        </b-button>
    </div>
        </div>
      </div>

      <div class="card shadow-sm">
        <div class="card-body p-4">
          <div class="row">
            <!-- Left and Middle Fields -->
            <div class="col-md-9">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="label-custom">Worker's Name :</label>
                  <b-form-input
                    v-model="form.worker_name.en"
                    class="form-control-custom"
                    readonly
                  ></b-form-input>
                  <label class="label-custom mt-1">শ্রমিকের নাম *:</label>
                  <b-form-input
                    v-model="form.worker_name.bn"
                    class="form-control-custom"
                    :readonly="!isEditMode"
                    :state="isEditMode && submitAttempted && (!form.worker_name.bn || !/^[\u0980-\u09FF ]+$/.test(form.worker_name.bn)) ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.worker_name.bn ? false : null">Worker's Name (Bangla) is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback :state="isEditMode && form.worker_name.bn && !/^[\u0980-\u09FF ]+$/.test(form.worker_name.bn) ? false : null">Worker's Name (Bangla) can only contain Bangla letters</b-form-invalid-feedback>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="label-custom">Father's Name *:</label>
                  <b-form-input
                    v-model="form.father_name.en"
                    class="form-control-custom"
                    :readonly="!isEditMode"
                    :state="isEditMode && submitAttempted && (!form.father_name.en || !/^[A-Za-z .-]+$/.test(form.father_name.en)) ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.father_name.en ? false : null">Father's Name (English) is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback :state="isEditMode && form.father_name.en && !/^[A-Za-z .-]+$/.test(form.father_name.en) ? false : null">Father's Name (English) can only contain English letters</b-form-invalid-feedback>
                  <label class="label-custom mt-1">পিতার নাম *:</label>
                  <b-form-input
                    v-model="form.father_name.bn"
                    class="form-control-custom"
                    :readonly="!isEditMode"
                    :state="isEditMode && submitAttempted && (!form.father_name.bn || !/^[\u0980-\u09FF .-]+$/.test(form.father_name.bn)) ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.father_name.bn ? false : null">Father's Name (Bangla) is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback :state="isEditMode && form.father_name.bn && !/^[\u0980-\u09FF .-]+$/.test(form.father_name.bn) ? false : null">Father's Name (Bangla) can only contain Bangla letters</b-form-invalid-feedback>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="label-custom">Mother's Name *:</label>
                  <b-form-input
                    v-model="form.mother_name.en"
                    class="form-control-custom"
                    :readonly="!isEditMode"
                    :state="isEditMode && submitAttempted && (!form.mother_name.en || !/^[A-Za-z .-]+$/.test(form.mother_name.en)) ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.mother_name.en ? false : null">Mother's Name (English) is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback :state="isEditMode && form.mother_name.en && !/^[A-Za-z .-]+$/.test(form.mother_name.en) ? false : null">Mother's Name (English) can only contain English letters</b-form-invalid-feedback>
                  <label class="label-custom mt-1">মাতার নাম *:</label>
                  <b-form-input
                    v-model="form.mother_name.bn"
                    class="form-control-custom"
                    :readonly="!isEditMode"
                    :state="isEditMode && submitAttempted && (!form.mother_name.bn || !/^[\u0980-\u09FF .-]+$/.test(form.mother_name.bn)) ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.mother_name.bn ? false : null">Mother's Name (Bangla) is required</b-form-invalid-feedback>
                  <b-form-invalid-feedback :state="isEditMode && form.mother_name.bn && !/^[\u0980-\u09FF .-]+$/.test(form.mother_name.bn) ? false : null">Mother's Name (Bangla) can only contain Bangla letters</b-form-invalid-feedback>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="label-custom"
                    >Spouse's Name (if applicable):</label
                  >
                  <b-form-input
                    v-model="form.spouse_name.en"
                    class="form-control-custom"
                    readonly
                  ></b-form-input>
                  <label class="label-custom mt-1"
                    >স্বামী/স্ত্রীর নাম (প্রযোজ্য ক্ষেত্রে):</label
                  >
                  <b-form-input
                    v-model="form.spouse_name.bn"
                    class="form-control-custom"
                    :readonly="!isEditMode"
                    :state="isEditMode && form.spouse_name.bn && !/^[\u0980-\u09FF ]*$/.test(form.spouse_name.bn) ? false : null"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="isEditMode && form.spouse_name.bn && !/^[\u0980-\u09FF ]*$/.test(form.spouse_name.bn) ? false : null">Spouse Name (Bangla) can only contain Bangla letters</b-form-invalid-feedback>
                </div>
              </div>

              <div class="mt-4">
                <h6 class="font-weight-bold" style="font-size: 0.9rem">
                  Permanent Address স্থায়ী ঠিকানা:
                </h6>
                <hr class="mt-1 mb-3" />
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="label-custom">District *:</label>
                    <b-form-select
                      v-model="form.permanent_district.en"
                      :options="districtOptions"
                      class="form-control-custom"
                      :disabled="!isEditMode"
                      :state="isEditMode && submitAttempted && !form.permanent_district.en ? false : null"
                      @change="onDistrictChange"
                    ></b-form-select>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_district.en ? false : null">District (English) is required</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="label-custom">জেলা *:</label>
                    <b-form-select
                      v-model="form.permanent_district.bn"
                      :options="districtOptionsBn"
                      class="form-control-custom"
                      :disabled="!isEditMode"
                      :state="isEditMode && submitAttempted && !form.permanent_district.bn ? false : null"
                    ></b-form-select>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_district.bn ? false : null">District (Bangla) is required</b-form-invalid-feedback>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="label-custom">SubDistrict *:</label>
                    <b-form-select
                      v-model="form.permanent_sub_district.en"
                      :options="subdistrictOptions"
                      class="form-control-custom"
                      :disabled="!isEditMode || !form.permanent_district.en"
                      :state="isEditMode && submitAttempted && !form.permanent_sub_district.en ? false : null"
                      @change="onSubDistrictChange"
                    ></b-form-select>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_sub_district.en ? false : null">Sub-District (English) is required</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="label-custom">উপজেলা *:</label>
                    <b-form-select
                      v-model="form.permanent_sub_district.bn"
                      :options="subdistrictOptionsBn"
                      class="form-control-custom"
                      :disabled="!isEditMode || !form.permanent_district.bn"
                      :state="isEditMode && submitAttempted && !form.permanent_sub_district.bn ? false : null"
                    ></b-form-select>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_sub_district.bn ? false : null">উপজেলা (Bangla) is required</b-form-invalid-feedback>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="label-custom">Police Station *:</label>
                    <b-form-input
                      v-model="form.permanent_police_station.en"
                      class="form-control-custom"
                      :readonly="!isEditMode"
                      :state="isEditMode && submitAttempted && (!form.permanent_police_station.en || !/[A-Za-z]/.test(form.permanent_police_station.en)) ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_police_station.en ? false : null">Police Station (English) is required</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="label-custom">থানা *:</label>
                    <b-form-input
                      v-model="form.permanent_police_station.bn"
                      class="form-control-custom"
                      :readonly="!isEditMode"
                      :state="isEditMode && submitAttempted && (!form.permanent_police_station.bn || !/[\u0980-\u09FF]/.test(form.permanent_police_station.bn)) ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_police_station.bn ? false : null">Police Station (Bangla) is required</b-form-invalid-feedback>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="label-custom">Post Office *:</label>
                    <b-form-input
                      v-model="form.permanent_post_office.en"
                      class="form-control-custom"
                      :readonly="!isEditMode"
                      :state="isEditMode && submitAttempted && (!form.permanent_post_office.en || !/[A-Za-z]/.test(form.permanent_post_office.en)) ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_post_office.en ? false : null">Post Office (English) is required</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="label-custom">ডাকঘর *:</label>
                    <b-form-input
                      v-model="form.permanent_post_office.bn"
                      class="form-control-custom"
                      :readonly="!isEditMode"
                      :state="isEditMode && submitAttempted && (!form.permanent_post_office.bn || !/[\u0980-\u09FF]/.test(form.permanent_post_office.bn)) ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_post_office.bn ? false : null">ডাকঘর (Bangla) is required</b-form-invalid-feedback>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="label-custom">Village/Area *:</label>
                    <b-input-group>
                      <template #prepend>
                        <b-form-select
                          v-model="addr_prefix"
                          :options="['Village', 'Area']"
                          class="rounded-left"
                          :disabled="!isEditMode"
                        ></b-form-select>
                      </template>
                      <b-form-input
                        v-model="form.permanent_village.en"
                        class="form-control-custom"
                        :readonly="!isEditMode"
                        :state="isEditMode && submitAttempted && (!form.permanent_village.en || !/[A-Za-z]/.test(form.permanent_village.en)) ? false : null"
                      ></b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_village.en ? false : null">Village/Area (English) is required</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="label-custom">স্থায়ী গ্রাম/মহল্লা *:</label>
                    <b-form-input
                      v-model="form.permanent_village.bn"
                      class="form-control-custom"
                      :readonly="!isEditMode"
                      :state="isEditMode && submitAttempted && (!form.permanent_village.bn || !/[\u0980-\u09FF]/.test(form.permanent_village.bn)) ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_village.bn ? false : null">গ্রাম/মহল্লা (Bangla) is required</b-form-invalid-feedback>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label class="label-custom">Road *:</label>
                    <b-form-input
                      v-model="form.permanent_road.en"
                      class="form-control-custom"
                      :readonly="!isEditMode"
                      :state="isEditMode && submitAttempted && (!form.permanent_road.en || !/[A-Za-z0-9]/.test(form.permanent_road.en)) ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_road.en ? false : null">Road (English) is required</b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="isEditMode && form.permanent_road.en && !/[A-Za-z0-9]/.test(form.permanent_road.en) ? false : null">Road (English) must contain letters or numbers</b-form-invalid-feedback>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="label-custom">রাস্তা *:</label>
                    <b-form-input
                      v-model="form.permanent_road.bn"
                      class="form-control-custom"
                      :readonly="!isEditMode"
                      :state="isEditMode && submitAttempted && (!form.permanent_road.bn || !/[\u0980-\u09FF0-9]/.test(form.permanent_road.bn)) ? false : null"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.permanent_road.bn ? false : null">রাস্তা (Bangla) is required</b-form-invalid-feedback>
                    <b-form-invalid-feedback :state="isEditMode && form.permanent_road.bn && !/[\u0980-\u09FF0-9]/.test(form.permanent_road.bn) ? false : null">রাস্তা (Bangla) must contain Bangla letters or numbers</b-form-invalid-feedback>
                  </div>

                </div>
              </div>
            </div>

            <!-- Photo Upload Section -->
            <div class="col-md-3">
              <div class="photo-container text-center mb-3">
              <label class="label-custom d-block">Passport Size Photo:</label>
                <img
                  v-if="photo_preview"
                  :src="photo_preview"
                  class="rounded border mb-2"
                  style="width: 45mm; height: 55mm; object-fit: cover;"
                />
                <div
                  v-else
                  class="no-photo rounded border mb-2 d-flex align-items-center justify-content-center text-muted mx-auto"
                  style="width: 45mm; height: 55mm; background-color: #f8f9fa"
                >
                  <small>No Photo</small>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-4 mt-2">
            <label class="label-custom">Present Address *:</label>
            <b-form-textarea
              v-model="form.present_address.en"
              rows="1"
              class="form-control-custom mb-1"
              readonly
            ></b-form-textarea>
            <label class="label-custom">বর্তমান ঠিকানা *:</label>
            <b-form-textarea
              v-model="form.present_address.bn"
              rows="1"
              class="form-control-custom"
              :readonly="!isEditMode"
              :state="isEditMode && submitAttempted && (!form.present_address.bn || !/[\u0980-\u09FF0-9]/.test(form.present_address.bn)) ? false : null"
            ></b-form-textarea>
            <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.present_address.bn ? false : null">বর্তমান ঠিকানা (Bangla) is required</b-form-invalid-feedback>
            <b-form-invalid-feedback :state="isEditMode && form.present_address.bn && !/[\u0980-\u09FF0-9]/.test(form.present_address.bn) ? false : null">বর্তমান ঠিকানা must contain Bangla letters or numbers</b-form-invalid-feedback>
          </div>

          <!-- Row of 2 -->
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="label-custom"
                >Date of Birth জন্ম তারিখ (yyyy-mm-dd) (বছর-মাস-দিন):</label
              >
              <b-input-group>
                  <b-form-input
                    v-model="form.dob"
                    type="text"
                    placeholder="YYYY-MM-DD"
                    autocomplete="off"
                    class="form-control-custom"
                    readonly
                  ></b-form-input>
                  <b-input-group-append>
                    <b-form-datepicker
                      v-model="form.dob"
                      button-only
                      right
                      locale="en-US"
                      disabled
                    ></b-form-datepicker>
                  </b-input-group-append>
              </b-input-group>
            </div>
            <div class="col-md-6 mb-3">
              <label class="label-custom"
                >National ID Number জাতীয় পরিচয়পত্র নং (if available)(যদি উপলব্ধ থাকে):</label
              >
              <b-form-input
                v-model="form.nid_number"
                type="text"
                class="form-control-custom"
                readonly
              ></b-form-input>
            </div>
            <div class="col-md-6 mb-3">
              <label class="label-custom">Educational Qualification *:</label>
              <b-form-select
                v-model="form.educational_qualification.en"
                :options="educationOptions"
                class="form-control-custom mb-1 rounded-sm"
                :disabled="!isEditMode"
                :state="isEditMode && submitAttempted && !form.educational_qualification.en ? false : null"
                @change="onEducationChange"
              ></b-form-select>
              <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.educational_qualification.en ? false : null">Educational Qualification (English) is required</b-form-invalid-feedback>
              <label class="label-custom">শিক্ষাগত যোগ্যতা *:</label>
              <b-form-select
                v-model="form.educational_qualification.bn"
                :options="educationOptionsBn"
                class="form-control-custom rounded-sm"
                :disabled="!isEditMode"
                :state="isEditMode && submitAttempted && !form.educational_qualification.bn ? false : null"
              ></b-form-select>
              <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.educational_qualification.bn ? false : null">শিক্ষাগত যোগ্যতা (Bangla) is required</b-form-invalid-feedback>
            </div>
            <div class="col-md-6 mb-3">
              <label class="label-custom">Training or Special Skills :</label>
              <b-form-input
                v-model="form.training_special_skills.en"
                class="form-control-custom mb-1"
                :readonly="!isEditMode"
                :state="isEditMode && form.training_special_skills.en && (!/^[A-Za-z ,]+$/.test(form.training_special_skills.en) || !/[A-Za-z]/.test(form.training_special_skills.en)) ? false : null"
              ></b-form-input>
                <b-form-invalid-feedback :state="isEditMode && form.training_special_skills.en && (!/^[A-Za-z ,]+$/.test(form.training_special_skills.en) || !/[A-Za-z]/.test(form.training_special_skills.en)) ? false : null">Training/Skills (English) can only contain English letters, spaces, and commas</b-form-invalid-feedback>
              <label class="label-custom">প্রশিক্ষণ বা বিশেষ দক্ষতা :</label>
              <b-form-input
                v-model="form.training_special_skills.bn"
                class="form-control-custom"
                :readonly="!isEditMode"
                :state="isEditMode && form.training_special_skills.bn && (!/^[\u0980-\u09FF ,]+$/.test(form.training_special_skills.bn) || !/[\u0980-\u09FF]/.test(form.training_special_skills.bn)) ? false : null"
              ></b-form-input>
                <b-form-invalid-feedback :state="isEditMode && form.training_special_skills.bn && (!/^[\u0980-\u09FF ,]+$/.test(form.training_special_skills.bn) || !/[\u0980-\u09FF]/.test(form.training_special_skills.bn)) ? false : null">Training/Skills (Bangla) must contain at least one Bangla letter</b-form-invalid-feedback>
            </div>
            <div class="col-md-6 mb-3">
              <label class="label-custom">Height উচ্চতা:</label>
              <b-form-input
                v-model="form.height"
                class="form-control-custom"
                :readonly="!isEditMode"
                :state="isEditMode && form.height ? (isHeightValid(form.height) ? null : false) : null"
              ></b-form-input>
                <b-form-invalid-feedback :state="isEditMode && form.height && !isHeightValid(form.height) ? false : null">Height contains invalid characters. Use formats like 5 Feet 7, 5'7", 5 foot 7 inch</b-form-invalid-feedback>
            </div>
            <div class="col-md-6 mb-3">
              <label class="label-custom"
                >Blood Group রক্তের গ্রুপ (if known)(যদি জানা থাকে):</label
              >
              <b-form-select
                v-model="form.blood_group"
                :options="bloodGroupOptions"
                class="form-control-custom rounded-sm"
                disabled
              ></b-form-select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="label-custom">Any Identification mark(If available) :</label>
              <b-form-input
                v-model="form.identification_mark.en"
                class="form-control-custom mb-1"
                :readonly="!isEditMode"
                :state="isEditMode && form.identification_mark.en && (!/^[A-Za-z ,]+$/.test(form.identification_mark.en) || !/[A-Za-z]/.test(form.identification_mark.en)) ? false : null"
              ></b-form-input>
                <b-form-invalid-feedback :state="isEditMode && form.identification_mark.en && (!/^[A-Za-z ,]+$/.test(form.identification_mark.en) || !/[A-Za-z]/.test(form.identification_mark.en)) ? false : null">Identification Mark (English) can only contain English letters, spaces, and commas</b-form-invalid-feedback>
              <label class="label-custom">সনাক্ত করার চিহ্ন(যদি উপলব্ধ থাকে) :</label>
              <b-form-input
                v-model="form.identification_mark.bn"
                class="form-control-custom"
                :readonly="!isEditMode"
                :state="isEditMode && form.identification_mark.bn && (!/^[\u0980-\u09FF ,]+$/.test(form.identification_mark.bn) || !/[\u0980-\u09FF]/.test(form.identification_mark.bn)) ? false : null"
              ></b-form-input>
                <b-form-invalid-feedback :state="isEditMode && form.identification_mark.bn && (!/^[\u0980-\u09FF ,]+$/.test(form.identification_mark.bn) || !/[\u0980-\u09FF]/.test(form.identification_mark.bn)) ? false : null">Identification Mark (Bangla) must contain at least one Bangla letter</b-form-invalid-feedback>
            </div>
            <div class="col-md-6 mb-3">
              <label class="label-custom"
                >Date of Service Book Opening সার্ভিস বুক খোলার তারিখ *:</label
              >
              <b-input-group>
                <b-form-input
                  v-model="form.opening_date"
                  type="text"
                  placeholder="YYYY-MM-DD"
                  autocomplete="off"
                  class="form-control-custom"
                  :readonly="!isEditMode"
                  :state="isEditMode && submitAttempted && (!form.opening_date || !/^\d{4}-\d{2}-\d{2}$/.test(form.opening_date)) ? false : null"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    v-model="form.opening_date"
                    button-only
                    right
                    locale="en-US"
                    :disabled="!isEditMode"
                  ></b-form-datepicker>
                </b-input-group-append>
              </b-input-group>
              <b-form-invalid-feedback :state="isEditMode && submitAttempted && !form.opening_date ? false : null">Service Book Opening Date is required</b-form-invalid-feedback>
              <b-form-invalid-feedback :state="isEditMode && form.opening_date && !/^\d{4}-\d{2}-\d{2}$/.test(form.opening_date) ? false : null">Service Book Opening Date must be in YYYY-MM-DD format</b-form-invalid-feedback>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-4">
              <label class="label-custom d-block" style="min-height: 2.6em"
                >Worker's Signature শ্রমিকের স্বাক্ষর:</label
              >
              <div v-if="form.signature" class="mt-2">
                <b-link @click="downloadWithName(form.signature, 'Worker_Signature')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <div v-else class="text-muted small">No signature on file. Upload the worker's signature in the Employee Profile.</div>
            </div>

            <!-- Updated by Jarir 2026-04-26 — Employee Panel: view/download only, no upload (mirrors Worker's Signature pattern) -->
            <div class="col-md-4">
              <label class="label-custom d-block" style="min-height: 2.6em"
                >Worker's Thumb Impression শ্রমিকের বৃদ্ধাঙ্গুলির ছাপ:</label
              >
              <div v-if="form.worker_thumb_impression" class="mt-2">
                <b-link @click="downloadWithName(form.worker_thumb_impression, 'Worker_Thumb_Impression')">
                  <b-icon icon="download" scale="1.2"></b-icon> Download
                </b-link>
              </div>
              <div v-else class="text-muted small">No thumb impression on file.</div>

              <div v-if="isEditMode" class="mt-2">
                <b-form-file
                  placeholder="Upload thumb impression..."
                  drop-placeholder="Drop file here..."
                  size="sm"
                  accept="image/*"
                  @change="onThumbChange"
                ></b-form-file>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- </div> -->
  </b-overlay>
</template>
<script>
export default {
  props: {
    isEmbedded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      apiPrefix: "/front/service-book", // Fixed to front for Employee side
      loading: false,
      pdfLoading: false,
      isEditMode: false,
      addr_prefix: "Village",
      photo_preview: null,
      sig_preview: null,
      thumb_preview: null,
      thumb_file: null,
      thumb_name: "",
      owner_sig_preview: null,
      locations: [],
      locationsBn: [],
      bloodGroupOptions: [
        { value: "", text: "Select Blood Group" },
        "A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-",
      ],
      educationOptions: [
        { value: "", text: "Select Qualification" },
        "No Formal Education",
        "Primary Education / Class 5",
        "Junior School Certificate (JSC) / Class 8",
        "Secondary School Certificate (SSC) / Dakhil / Equivalent",
        "Higher Secondary Certificate (HSC) / Alim / Vocational Diploma / Equivalent",
        "Bachelor's Degree (Pass) / Pass Course",
        "Bachelor's Degree (Honours) / Equivalent",
        "Master's Degree",
        "Doctorate or Higher (PhD/MPhil)",
      ],
      educationOptionsBn: [
        { value: "", text: "যোগ্যতা নির্বাচন করুন" },
        "প্রাতিষ্ঠানিক শিক্ষা নেই",
        "প্রাথমিক শিক্ষা / পঞ্চম শ্রেণি",
        "জুনিয়র স্কুল সার্টিফিকেট (জেএসসি) / অষ্টম শ্রেণি",
        "মাধ্যমিক স্কুল সার্টিফিকেট (এসএসসি) / দাখিল / সমমান",
        "উচ্চ মাধ্যমিক সার্টিফিকেট (এইচএসসি) / আলিম / ভোকেশনাল ডিপ্লোমা / সমমান",
        "স্নাতক (পাস) / পাস কোর্স",
        "স্নাতক (সম্মান) / সমমান",
        "স্নাতকোত্তর (মাস্টার্স)",
        "ডক্টরেট বা উচ্চতর (পিএইচডি / এমফিল)",
      ],
      form: {
        worker_name: { en: "", bn: "" },
        father_name: { en: "", bn: "" },
        mother_name: { en: "", bn: "" },
        spouse_name: { en: "", bn: "" },
        permanent_village: { en: "", bn: "" },
        permanent_road: { en: "", bn: "" },
        permanent_post_office: { en: "", bn: "" },
        permanent_police_station: { en: "", bn: "" },
        permanent_sub_district: { en: "", bn: "" },
        permanent_district: { en: "", bn: "" },
        present_address: { en: "", bn: "" },
        dob: "",
        nid_number: "",
        educational_qualification: { en: "", bn: "" },
        training_special_skills: { en: "", bn: "" },
        height: "",
        blood_group: "",
        identification_mark: { en: "", bn: "" },
        opening_date: "",
      },
      submitAttempted: false,
    };
  },
  watch: {
    form: {
      deep: true,
      handler: function () {
        this.sanitizeAllFormFields();
      },
    },
  },
  computed: {
    districtOptions() {
      const districts = [...new Set(this.locations.map((item) => item.district))];
      return [{ value: "", text: "Select District" }, ...districts.sort().map((d) => ({ value: d, text: d }))];
    },
    subdistrictOptions() {
      if (!this.form.permanent_district.en) return [{ value: "", text: "Select Sub-district" }];
      const subdistricts = [...new Set(this.locations.filter((item) => item.district === this.form.permanent_district.en).map((item) => item.subdistrict))];
      return [{ value: "", text: "Select Sub-district" }, ...subdistricts.sort().map((s) => ({ value: s, text: s }))];
    },
    districtOptionsBn() {
      const districts = [...new Set(this.locationsBn.map((item) => item.district))];
      return [{ value: "", text: "জেলা নির্বাচন করুন" }, ...districts.sort().map((d) => ({ value: d, text: d }))];
    },
    subdistrictOptionsBn() {
      if (!this.form.permanent_district.bn) return [{ value: "", text: "উপজেলা নির্বাচন করুন" }];
      const subdistricts = [...new Set(this.locationsBn.filter((item) => item.district === this.form.permanent_district.bn).map((item) => item.subdistrict))];
      return [{ value: "", text: "উপজেলা নির্বাচন করুন" }, ...subdistricts.sort().map((s) => ({ value: s, text: s }))];
    },
  },
  created() {
    this.fetchData();
    this.fetchLocations();
  },
  methods: {
    sanitizeEnText: function (v) {
      if (v == null) return v;
      return String(v).replace(/[^A-Za-z0-9 ,.\-]/g, "");
    },
    sanitizeBnText: function (v) {
      if (v == null) return v;
      return String(v).replace(/[^\u0980-\u09FF0-9 ,।\-]/g, "");
    },
    sanitizeAllFormFields: function () {
      // Updated by Jarir 2026-04-21 — Names (Worker, Father, Mother, Spouse) are excluded from automatic stripping
      // so that saveData validation can catch invalid characters (numbers/special chars) and show errors.
      var enFields = [];
      var bnFields = [];
      for (var i = 0; i < enFields.length; i++) {
        var k = enFields[i];
        if (this.form[k] && typeof this.form[k] === "object" && "en" in this.form[k]) {
          var cleanEn = this.sanitizeEnText(this.form[k].en);
          if (cleanEn !== this.form[k].en) this.$set(this.form[k], "en", cleanEn);
        }
      }
      for (var j = 0; j < bnFields.length; j++) {
        var kb = bnFields[j];
        if (this.form[kb] && typeof this.form[kb] === "object" && "bn" in this.form[kb]) {
          var cleanBn = this.sanitizeBnText(this.form[kb].bn);
          if (cleanBn !== this.form[kb].bn) this.$set(this.form[kb], "bn", cleanBn);
        }
      }
    },
    findHtmlOrPhpField(data, prefix) {
      const pattern = /<[a-zA-Z!?\/]/;
      if (data === null || data === undefined) return null;
      if (typeof data === "string") {
        if (data && pattern.test(data)) return prefix || "field";
        return null;
      }
      if (typeof data === "object") {
        for (const key in data) {
          if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
          const field = prefix ? prefix + "." + key : key;
          const hit = this.findHtmlOrPhpField(data[key], field);
          if (hit) return hit;
        }
      }
      return null;
    },
    fetchAsBlob(url) {
      if (!url) return Promise.resolve(null);
      return fetch(url, { credentials: 'same-origin' })
        .then(r => r.blob())
        .then(blob => URL.createObjectURL(blob))
        .catch(() => url);
    },
    fetchLocations() {
      axios
        .post(this.$api_url + this.apiPrefix + "/get-locations", {})
        .then((response) => {
          this.locations = response.data;
          axios.post(this.$api_url + this.apiPrefix + "/get-locations", { lang: 'bn' })
            .then(res => { this.locationsBn = res.data; });
        });
    },
    onDistrictChange(val) {
      this.form.permanent_sub_district.en = "";
      this.form.permanent_sub_district.bn = "";
      this.form.permanent_post_office.en = "";
      this.form.permanent_post_office.bn = "";

      if (val) {
        const index = this.locations.findIndex(item => item.district === val);
        if (index !== -1 && this.locationsBn[index]) {
          this.form.permanent_district.bn = this.locationsBn[index].district;
        }
      }
    },
    onSubDistrictChange(val) {
      this.form.permanent_post_office.en = "";
      this.form.permanent_post_office.bn = "";

      if (val) {
        const index = this.locations.findIndex(item =>
          item.district === this.form.permanent_district.en &&
          item.subdistrict === val
        );
        if (index !== -1 && this.locationsBn[index]) {
          this.form.permanent_sub_district.bn = this.locationsBn[index].subdistrict;
        }
      }
    },
    onEducationChange(val) {
      if (val) {
        const index = this.educationOptions.findIndex(o =>
          (typeof o === 'string' ? o : o.value) === val
        );
        if (index !== -1 && this.educationOptionsBn[index]) {
          this.form.educational_qualification.bn = typeof this.educationOptionsBn[index] === 'string'
            ? this.educationOptionsBn[index]
            : this.educationOptionsBn[index].value;
        }
      }
    },
    fetchData() {
      this.loading = true;
      axios.post(this.$api_url + this.apiPrefix + "/get-worker-identification", {})
        .then((response) => {
          if (response.data) {
            const doc = response.data;
            const fields = ["worker_name", "father_name", "mother_name", "spouse_name", "permanent_village", "permanent_road", "permanent_post_office", "permanent_police_station", "permanent_sub_district", "permanent_district", "present_address", "educational_qualification", "training_special_skills", "identification_mark"];
            fields.forEach((field) => { doc[field] = this.getJsonValue(doc[field]); });
            this.form = Object.assign({}, this.form, doc);
            ['nid_number', 'blood_group', 'dob'].forEach((k) => { if (this.form[k] == 'null' || this.form[k] == null) this.form[k] = ''; });
            if (this.form.dob) this.form.dob = (this.form.dob + '').substring(0, 10);
            if (this.form.opening_date) this.form.opening_date = (this.form.opening_date + '').substring(0, 10);

            if (this.form.photo) this.fetchAsBlob(this.getImageUrl(this.form.photo)).then(b => { this.photo_preview = b; });
            if (this.form.signature) this.fetchAsBlob(this.getImageUrl(this.form.signature)).then(b => { this.sig_preview = b; });
            if (this.form.worker_thumb_impression) this.fetchAsBlob(this.getImageUrl(this.form.worker_thumb_impression)).then(b => { this.thumb_preview = b; });
            if (this.form.owner_signature) this.fetchAsBlob(this.getImageUrl(this.form.owner_signature)).then(b => { this.owner_sig_preview = b; });
          }
        })
        .finally(() => { this.loading = false; });
    },
    getJsonValue(v) {
      if (!v) return { en: "", bn: "" };
      if (typeof v === "object") return v;
      try { return JSON.parse(v); } catch (e) { return { en: v, bn: "" }; }
    },
    getImageUrl(path) {
      if (!path) return null;
      if (path.startsWith("http") || path.startsWith("data:")) return path;
      return "/" + path;
    },
    isHeightValid(v) {
      if (!v) return true;
      // Allowed characters: digits, spaces, and height-related words/symbols
      if (!/^([0-9\u09E6-\u09EF\s'\"’‘]|Feet|ft|inch|in|ফুট|ইঞ্চি)+$/i.test(v)) return false;
      // Must contain at least one height signifier (word or symbol) to distinguish from random numbers
      return /['\"’‘]|Feet|ft|inch|in|ফুট|ইঞ্চি/i.test(v);
    },
    downloadWithName(path, name) {
      if (!path) return;

      // Updated by Jarir 2026-05-04 — handle Base64 image downloads via Blob (Prevents /ghostme server errors for data URIs)
      if (path.startsWith('data:image/')) {
        try {
          const parts = path.split(';base64,');
          const contentType = parts[0].split(':')[1];
          const raw = window.atob(parts[1]);
          const rawLength = raw.length;
          const uInt8Array = new Uint8Array(rawLength);
          for (let i = 0; i < rawLength; ++i) uInt8Array[i] = raw.charCodeAt(i);
          const blob = new Blob([uInt8Array], { type: contentType });
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = name + '.' + contentType.split('/')[1];
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
          return;
        } catch (e) {
          console.error("Base64 download failed, falling back to direct URL", e);
        }
      }

      const url = this.getImageUrl(path);
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadPdf(lang = "both") {
      this.pdfLoading = true;
      axios.post(this.$api_url + this.apiPrefix + "/download-worker-identification-pdf", { lang: lang }, { responseType: "blob" })
        .then((response) => { this.global_download_file_content(response); })
        .finally(() => { this.pdfLoading = false; });
    },
    saveData() {
      let errors = [];

      // Updated by Jarir 2026-04-09 — Block HTML tags / PHP code in any text field before save
      const badField = this.findHtmlOrPhpField(this.form);
      if (badField) {
        errors.push("Invalid Input (HTML/PHP tags detected)");
      }

      // Updated by Jarir 2026-04-21 : Name validation (Letters only)
      const nameFields = [
        { key: "father_name", label: "Father's Name" },
        { key: "mother_name", label: "Mother's Name" },
      ];
      const enNameRegex = /^[A-Za-z ]*$/;
      const bnNameRegex = /^[\u0980-\u09FF ]*$/;

      for (const field of nameFields) {
        const val = this.form[field.key];
        if (val.en && !enNameRegex.test(val.en)) {
          errors.push(`${field.label} (English) can only contain English letters and spaces`);
        }
        if (val.bn && !bnNameRegex.test(val.bn)) {
          errors.push(`${field.label} (Bangla) can only contain Bangla letters and spaces`);
        }
      }

      // Updated by Jarir 2026-04-21 : Address validation (Alphanumeric with symbols, but must have letters)
      const addrFields = [
        { key: "permanent_village", label: "Village/Area" },
        { key: "permanent_road", label: "Road" },
        { key: "permanent_post_office", label: "Post Office" },
        { key: "permanent_police_station", label: "Police Station" },
      ];
      const enAddrRegex = /.*/;
      const bnAddrRegex = /.*/;

      for (const field of addrFields) {
        const val = this.form[field.key];
        if (val.en) {
          if (!enAddrRegex.test(val.en)) {
            errors.push(`${field.label} (English) contains invalid special characters`);
          } else if (!/[A-Za-z]/.test(val.en)) {
            errors.push(`${field.label} (English) must contain at least one letter (cannot be only numbers or symbols)`);
          }
        }
        if (val.bn) {
          if (!bnAddrRegex.test(val.bn)) {
            errors.push(`${field.label} (Bangla) contains invalid special characters`);
          } else if (!/[\u0980-\u09FF]/.test(val.bn)) {
            errors.push(`${field.label} (Bangla) must contain at least one letter (cannot be only numbers or symbols)`);
          }
        }
      }

      // Updated by Jarir 2026-04-21 : Skills & Identification validation (Letters, spaces, commas only)
      const skillFields = [
        { key: "training_special_skills", label: "Training or Special Skills" },
        { key: "identification_mark", label: "Identification Mark" },
      ];
      const enSkillRegex = /^[A-Za-z ,]*$/;
      const bnSkillRegex = /^[\u0980-\u09FF ,]*$/;

      for (const field of skillFields) {
        const val = this.form[field.key];
        if (val.en) {
          if (!enSkillRegex.test(val.en)) {
            errors.push(`${field.label} (English) can only contain English letters, spaces, and commas`);
          } else if (!/[A-Za-z]/.test(val.en)) {
            errors.push(`${field.label} (English) must contain at least one letter`);
          }
        }
        if (val.bn) {
          if (!bnSkillRegex.test(val.bn)) {
            errors.push(`${field.label} (Bangla) can only contain Bangla letters, spaces, and commas`);
          } else if (!/[\u0980-\u09FF]/.test(val.bn)) {
            errors.push(`${field.label} (Bangla) must contain at least one letter`);
          }
        }
      }

      // Updated by Jarir 2026-04-21 : Height validation (using helper method)
      if (this.form.height && !this.isHeightValid(this.form.height)) {
        errors.push("Height contains invalid characters or format. Use formats like 5 Feet 7, 5'7\", ৫ ফুট ৭ ইঞ্চি etc.");
      }

      this.submitAttempted = true;

      // Required fields validation
      if (!this.form.father_name.en) errors.push("Father's Name (English)");
      if (!this.form.father_name.bn) errors.push("Father's Name (Bangla)");
      if (!this.form.mother_name.en) errors.push("Mother's Name (English)");
      if (!this.form.mother_name.bn) errors.push("Mother's Name (Bangla)");
      if (!this.form.permanent_district.en) errors.push("District (English)");
      if (!this.form.permanent_district.bn) errors.push("District (Bangla)");
      if (!this.form.permanent_sub_district.en) errors.push("Sub-district (English)");
      if (!this.form.permanent_sub_district.bn) errors.push("Sub-district (Bangla)");
      if (!this.form.permanent_police_station.en) errors.push("Police Station (English)");
      if (!this.form.permanent_police_station.bn) errors.push("Police Station (Bangla)");
      if (!this.form.permanent_post_office.en) errors.push("Post Office (English)");
      if (!this.form.permanent_post_office.bn) errors.push("Post Office (Bangla)");
      if (!this.form.permanent_village.en) errors.push("Village/Area (English)");
      if (!this.form.permanent_village.bn) errors.push("Village/Area (Bangla)");
      if (!this.form.permanent_road.en) errors.push("Road (English)");
      if (!this.form.permanent_road.bn) errors.push("Road (Bangla)");
      if (!this.form.present_address.bn) errors.push("Present Address (Bangla)");
      if (!this.form.opening_date) {
        errors.push("Service Book Opening Date");
      } else if (!/^\d{4}-\d{2}-\d{2}$/.test(this.form.opening_date)) {
        errors.push("Service Book Opening Date must be in YYYY-MM-DD format");
      }

      if (errors.length > 0) {
        this.$bvToast.toast('Please fill all required fields [marked red]', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }

      this.loading = true;
      let formData = new FormData();
      const jsonFields = ["worker_name", "father_name", "mother_name", "spouse_name", "permanent_village", "permanent_road", "permanent_post_office", "permanent_police_station", "permanent_sub_district", "permanent_district", "present_address", "educational_qualification", "training_special_skills", "identification_mark"];

      if (this.thumb_file) formData.append("worker_thumb_impression", this.thumb_file);

      for (let key in this.form) {
        if (this.form[key] !== null) {
          if (['dob', 'nid_number', 'blood_group', 'signature', 'worker_thumb_impression', 'owner_signature', 'photo'].includes(key)) continue;
          if (jsonFields.includes(key)) formData.append(key, JSON.stringify(this.form[key]));
          else formData.append(key, this.form[key]);
        }
      }

      axios.post(this.$api_url + this.apiPrefix + "/save-worker-identification", formData, { headers: { "Content-Type": "multipart/form-data" } })
        .then(() => {
          this.isEditMode = false;
          this.thumb_file = null;
          this.thumb_preview = null;
          this.$bvToast.toast("Saved successfully", { title: "Success", variant: "success", solid: true, autoHideDelay: 3000 });
          this.fetchData();
        })
        .catch((error) => {
          let msg = "Failed to save data";
          if (error.response && error.response.data && error.response.data.error) {
            msg = error.response.data.error;
          }
          this.$bvToast.toast(msg, { title: "Error", variant: "danger", solid: true, autoHideDelay: 5000 });
        })
        .finally(() => { this.loading = false; });
    },
    onThumbChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.thumb_file = file;
        this.thumb_name = file.name;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.thumb_preview = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    toggleEditMode() {
      this.isEditMode = !this.isEditMode;
    },
  },
};
</script>
<style scoped>
.worker-id-document { padding: 5px; }
.label-custom { font-weight: 600; font-size: 0.85rem; color: #444; margin-bottom: 2px; }
.form-control-custom { border-radius: 4px; border: 1px solid #ced4da; font-size: 0.9rem; padding: 0.4rem 0.6rem; transition: border-color 0.2s; }
.form-control-custom:focus { border-color: #80bdff; outline: 0; box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
.sig-container { min-height: 85px; display: flex; align-items: center; justify-content: center; background-color: #fafafa; }

/* Grey out readonly/disabled fields for clear visual distinction */
.form-control-custom[readonly],
.form-control-custom:disabled,
::v-deep .form-control[readonly],
::v-deep .form-control:disabled,
::v-deep .custom-select[readonly],
::v-deep .custom-select:disabled {
  background-color: #e9ecef !important;
  color: #6c757d !important;
  cursor: not-allowed;
  opacity: 1;
}
</style>
